import type { FC } from "react";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { DetailRow } from "web_myplann/Portfolio/Components/Redesign/Detail/DetailRow";
import { moneyFormatter } from "web_myplann/Shared/Utils/moneyFormatters";

const PageResources = Resources.PortfolioDetail.Property;

type Props = {
	reproductionValue: number | null | undefined;
	interiorValue: number | null | undefined;
	currencySign: string;
};

export const PropertyValueRows: FC<Props> = ({
	reproductionValue,
	interiorValue,
	currencySign,
}) => {
	const { t } = useResource();

	return (
		<>
			<DetailRow
				label={t(PageResources.ReproductionPrice)}
				value={moneyFormatter(reproductionValue, currencySign)}
			/>
			<DetailRow
				label={t(PageResources.InteriorPrice)}
				value={moneyFormatter(interiorValue, currencySign)}
			/>
		</>
	);
};
